import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import SidebarCard from './SidebarCard';
import { getProducts } from '../api';

/* Products from the site's library attached to this page (Save to DAM extension). */
export default function ProductsCard({ domainId, slug, open, onToggle }) {
  const [products, setProducts] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!slug) return undefined;
    let cancelled = false;
    getProducts(domainId, slug)
      .then((list) => { if (!cancelled) setProducts(list); })
      .catch(() => { if (!cancelled) setError('Could not load products'); });
    return () => { cancelled = true; };
  }, [domainId, slug]);

  const count = products ? products.length : null;
  return (
    <SidebarCard
      id="products"
      title={`Products for this page${count != null ? ` (${count})` : ''}`}
      open={open}
      onToggle={onToggle}
    >
      {error && <div className="muted small">{error}</div>}
      {!error && products === null && <div className="muted small">Loading…</div>}
      {products && products.length === 0 && (
        <div className="muted small">None yet. Save products to this page with the Save to DAM extension.</div>
      )}
      {products && products.length > 0 && (
        <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
          {products.map((p) => (
            <li key={p.asin} style={{ display: 'flex', gap: 8, alignItems: 'flex-start', padding: '6px 0', borderTop: '1px solid var(--color-border)' }}>
              {p.image_url && (
                <img src={p.image_url} alt="" loading="lazy" referrerPolicy="no-referrer"
                     style={{ width: 40, height: 40, objectFit: 'contain', flexShrink: 0 }} />
              )}
              <div style={{ fontSize: 12, minWidth: 0 }}>
                <a href={p.detail_url} target="_blank" rel="noopener noreferrer" style={{ fontWeight: 500 }}>
                  {p.title || p.asin}
                </a>
                <div className="muted">
                  {p.rating != null ? `${p.rating}★ · ` : ''}{p.price_band ? `${p.price_band} · ` : ''}{p.status || 'inbox'}
                </div>
                {p.notes && <div className="muted" style={{ whiteSpace: 'pre-line' }}>{p.notes}</div>}
              </div>
            </li>
          ))}
        </ul>
      )}
      <div style={{ marginTop: 6 }}>
        <Link className="small" to={`/domain/${domainId}/products?page=${encodeURIComponent(slug || '')}`}>Open product library →</Link>
      </div>
    </SidebarCard>
  );
}
